const rows = document.querySelectorAll('.removable-row');

rows.forEach(row => {
    row.addEventListener('click', function(event) {
        /* Prevent row click if "Eliminar" button is clicked */
        if (event.target.classList.contains('remove-btn')) {
            return;
        }

        /* Remove previously selected row's highlight */
        document.querySelectorAll('.selected-row').forEach(selected => {
            selected.classList.remove('bg-gray-300', 'dark:bg-gray-600');
        });

        /* Highlight the selected row */
        this.classList.add('bg-gray-300', 'dark:bg-gray-600', 'selected-row');
    });
});

/* Get all "Eliminar" buttons */
const removeButtons = document.querySelectorAll('.remove-btn');

removeButtons.forEach(button => {
    button.addEventListener('click', function(event) {
        /* Prevent row click event from triggering */
        event.stopPropagation();

        /* Find the closest row with class "removable-row" and remove it */
        this.closest('.removable-row').remove();
    });
});